import createDocumentResource from 'src/actions/shared/createDocumentResource';

class ConversationWorkflow {
  requireTopics: boolean;
  reopenConversationWindow: string;
  sidekickAssignedAgentId?: string;
}

export default createDocumentResource<ConversationWorkflow>({
  name: 'conversationWorkflow',
  endpoint: ' v1/orgs/:orgId/configuration/conversation-workflow',
  type: ConversationWorkflow,
});
